import React from 'react';
import Tag from 'antd/lib/tag';
import { BASE_COLOR } from '../../../../theme';
import { Checkbox } from 'antd/lib';
import { useSiteMapStore } from './useSiteMapStore';

export const CarbonIntensityMapLegends: React.FC = () => {
    const showCarbonIntensityMap = useSiteMapStore(state => state.showCarbonIntensityMap);
    const setShowCarbonIntensityMap = useSiteMapStore(state => state.setShowCarbonIntensityMap);

    return (
        <div className="map-legend">
            <Checkbox checked={showCarbonIntensityMap} onChange={val => setShowCarbonIntensityMap(val.target.checked)}>
                Carbon Intensity (lbs CO2 per MW)&nbsp;&nbsp;
            </Checkbox>
            {showCarbonIntensityMap && (
                <>
                    <Tag>no data</Tag>
                    <Tag color="#FFFFB0">
                        <span style={{ color: BASE_COLOR }}>&nbsp;&gt; 0 &nbsp;</span>
                    </Tag>
                    <Tag color="rgba(224, 176, 64, 0.4)">&gt; 200</Tag>
                    <Tag color="rgba(160, 96, 48, 0.4)">&gt; 400</Tag>
                    <Tag color="rgba(96, 32, 32,  0.4)">&gt; 600</Tag>
                    <Tag color="rgba(0, 0, 16, 0.4)">&gt; 800</Tag>
                </>
            )}
        </div>
    );
};
